<template>
  <div
    class="slider-container"
    v-bind:style="{ 'min-height': viewHeight ? viewHeight : '500px' }"
  >
    <div class="photo">
      <avatar></avatar>
      <div v-if="!isSmallDisplay" class="white--text">
        <p class="julia-archievement">
          <!-- Value of properties sold in 2020: $14,094,500 -->
          Ranked #13 in RE/MAX California in 2023<br />
          Ranked #41 in RE/MAX Nationwide in 2023<br />
          RE/MAX Circle of Legend Reward<br />
          Top 1% Agents RE/MAX Worldwide<br />
          L.A. Five Star Real Estate Professional Winner
        </p>
        <!-- <a itemprop="telephone" href="tel:001-626-390-8870" style="color:white">
          <v-icon color="white" size="18">fas fa-phone</v-icon>
          <span class="pl-2">626-390-8870</span></a> -->
      </div>
    </div>
    <!-- <span class="sale-label">Active</span> -->
    <v-carousel
      light
      :height="viewHeight < viewWidth ? viewHeight : viewWidth * 0.66"
      v-model="carouselIndex"
      hide-delimiters
      :show-arrows="false"
      cycle
      :vertical="viewWidth > viewHeight"
    >
      <v-carousel-item v-for="(item, i) in properties" :key="i">
        <v-img
          :lazy-src="imgPath + item.id + '/thumbs/' + item.img"
          :src="imgPath + item.id + '/' + item.img"
          :width="viewWidth"
          :height="viewWidth < viewHeight ? 'auto' : viewHeight"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-carousel-item>
    </v-carousel>
    <div class="slider-banner">
      <div class="slider-title">
        {{ properties[carouselIndex].title }}<br />
        {{ formatPrice(properties[carouselIndex].price) }}
      </div>
      <div class="banner-button center">
        <v-btn small light fab @click="goToListing()">
          <v-icon small color="pink">fas fa-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

    <v-layout>
      <v-flex>
        <v-card>
          <v-container grid-list-sm fluid>
            <v-layout row wrap>
              <v-flex v-for="p in propertiesPics" :key="p" xs4 d-flex>
                <div class="center listing-card" style="overflow: hidden">
                  <v-card flat tile class="d-flex">
                    <!--<div v-view.once="imgInView">-->
                    <!--<div style="display:block" v-bind:id="'i'+p">-->
                    <v-img
                      :lazy-src="imgPath + currentPropertyId + '/thumbs/' + p"
                      :src="imgPath + currentPropertyId + '/' + p"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <!--</div>-->
                    <!--</div>-->
                  </v-card>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Utils } from "../utils";
import Avatar from "../components/Avatar";

// const MAX_PIC = 3

export default {
  name: "property-slider",
  components: {
    Avatar,
  },
  computed: {
    ...mapState({
      viewWidth: (state) => state.homeStore.viewWidth,
      viewHeight: (state) => state.homeStore.viewHeight - 60,
      isSmallDisplay: (state) => state.homeStore.isSmallDisplay,
      storeProperties: (state) =>
        state.listingStore.properties.filter(
          (e) => !e.sold && !e.leased && e.preview
        ),
    }),
    currentPropertyId: {
      get() {
        return this.properties[this.carouselIndex].id;
      },
      set(val) {},
    },
    currentPropertyIdx: {
      get() {
        return this.properties[this.carouselIndex].propIdx;
      },
      set(val) {},
    },
    propertiesPics: {
      get() {
        // if(this.storeProperties[this.currentPropertyIdx].picsWithTitle){
        //   let pics = []
        //   this.storeProperties[this.currentPropertyIdx].picsWithTitle.forEach((p, idx) => {
        //     if( idx < MAX_PIC ) pics.push(p.pic)
        //   })
        //   return pics
        // }
        return this.storeProperties[this.currentPropertyIdx].preview;
      },
      set(val) {},
    },
  },
  data() {
    return {
      imgPath: "http://www.juliazhao.com/realestate/properties/",
      carouselHeight: 0,
      carouselIndex: 0,
      properties: null,
    };
  },
  created() {
    this.properties = this.getProperties();
  },
  methods: {
    getProperties() {
      let picData = [];
      this.storeProperties.forEach((e, i) => {
        // if( e.picsWithTitle ) {
        //   e.picsWithTitle.forEach((p, idx) => {
        //     if(idx < MAX_PIC)
        //     picData.push({propIdx: i, id: e.id, title: e.title, price: e.price, img: p.pic})
        //   })
        // } else {
        e.preview.forEach((pic, idx) => {
          if (!e.sold)
            picData.push({
              propIdx: i,
              id: e.id,
              title: e.title,
              price: e.price,
              img: pic,
            });
        });
        // }
      });
      this.currentPropertyId = picData[0].id;
      return picData;
    },
    formatPrice: function (price) {
      return Utils.getPriceTxt(price, false);
    },
    goToListing() {
      this.$router.push("listing");
    },
  },
};
</script>

<style scoped>
@import "PropertyCarousel.css";
</style>
